// import currencies from "@data/currencies.json";
// import { loadStripe } from "@stripe/stripe-js";
import { FaDesktop, FaMobileAlt } from "react-icons/fa";

const url = process.env.REACT_APP_APPLICATION_NAME;
const getAppName = (appName) => {
  switch (appName) {
    case "provider":
      return {
        api_route: "/api/provider",
        auth_route: "/auth/provider",
      };
    case "admin":
      return {
        api_route: "/api/admin",
        auth_route: "/auth/admin",
      };
    default:
      return {
        api_route: "/api/main-laundry",
        auth_route: "/auth/laundry",
      };
  }
};
const { api_route, auth_route } = getAppName(url);

export const CONSTANTS = {
  // ======== USER ROLE
  AGENT: "super_admin",
  COMPANY: "store",

  APP_NAME: "IWASH",

  DEFAULTS: {},
  //   APP_URL: "https://updatemedaily.com/",
  BACKEND_URL: `https://iwash.updatemedaily.com${api_route}/`,
  BACKEND_URL_PUBLIC: `https://iwash.updatemedaily.com/api/public`,
  IMG_DIRECTORY: "https://iwash.updatemedaily.com/",
  BACKEND_URL_AUTH: `https://iwash.updatemedaily.com${auth_route}/`,

  // googleApikey: "AIzaSyCGNMdJkrhKP9pipRIc6T5ccTuZ4vXGMGo",
  googleApikey: "AIzaSyBMPlOkRyG9unslc3cLGq9ovKmINmzv-0g",
};

export const DEVICE_ICON_MAPPING = {
  mobile: <FaMobileAlt />,
  desktop: <FaDesktop />,
};

// export const JOB_STATUS = {
//   ACTIVE: "ACTIVE",
//   NON_ACTIVE: "NON ACTIVE",
// };

// export const stripePromise = loadStripe(CONSTANTS.STRIPE_PUBLIC_KEY);

// export const PAGE_ROLES = {
//   TICKETS: "tickets",
//   CHAT: "chat",
// };
